/* global $o */

import './globals'; // Adjust if needed
import React, { Component } from "react";
import screenfull from "screenfull";
import GIF from 'gif.js';
import "./App.css";
import process from "process";
window.process = process;

$o = window.$o

// Gradient sets
const gradientSets = [
  {
    id: "gradient1_momi-spectrum",
    gradient: "linear-gradient(180deg, #00ee3f, #00c8ff, #ffc000, #ff194f, #ff00ff, #6900d3, #ff0000, #ff9d00, #ffc400, #00ff26, #00ff9d)"
  },
  {
    id: "gradient2_cool-blue-green",
    gradient: "linear-gradient(180deg, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #2711F2)"
  },
  {
    id: "gradient3_descending-to-purple",
    gradient: "linear-gradient(180deg,#F4E8C1, #A0C1B9, #70A0AF, #C3BEF7, #8A4FFF)"
  },
  {
    id: "gradient4_pinks-many",
    gradient: "linear-gradient(180deg, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0, #FF1654, #FFAFF0)"
  },
  {
    id: "gradient5_blue-green",
    gradient: "linear-gradient(180deg, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #AFFCAF, #12DFF3, #37FF59, #A2F7FF, #AFFCAF, #12DFF3, #37FF59, #A2F7FF)"
  },
  {
    id: "gradient6_yellow-greens",
    gradient: "linear-gradient(180deg, #FFEB33, #37FF59, #2FFF00, #D9FF00, #00FF22, #FFEB33, #37FF59, #2FFF00,#FFEB33, #37FF59, #2FFF00, #D9FF00, #00FF22, #FFEB33, #37FF59, #2FFF00,#FFEB33, #37FF59, #2FFF00, #D9FF00, #00FF22, #FFEB33, #37FF59, #2FFF00)"
  },
  {
    id: "gradient7_like-dusk",
    gradient: "linear-gradient(180deg, #DFF2CB, #F0A13A, #EE609A, #DFF2CB, #F0A13A, #EE609A, #DFF2CB, #F0A13A, #EE609A, #DFF2CB, #F0A13A, #EE609A)"
  },
  {
    id: "gradient8_cyan-purple",
    gradient: "radial-gradient(circle at 40%, #48FFF3, #5DFFAE, #FFBFFE, #48FFF3, #5DFFAE, #FFBFFE, #48FFF3, #5DFFAE, #FFBFFE, #48FFF3, #5DFFAE, #FFBFFE, #48FFF3, #5DFFAE, #FFBFFE, #48FFF3, #5DFFAE, #FFBFFE)"
  },
  {
    id: "gradient9_high-sat-cyan-orange-magenta",
    gradient: "linear-gradient(180deg, #3BCFD4, #F20094, #FC9305, #F20094, #3BCFD4, #F20094, #FC9305, #F20094, #3BCFD4, #F20094, #FC9305, #F20094)"
  },
  {
    id: "gradient10_two-blues-horizon",
    gradient: "radial-gradient(circle at 20% -50%,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff,#0061ff, #60efff)"
  },
  {
    id: "gradient11_sunrise-on-the-sun",
    gradient: "radial-gradient(circle at -20% 250%, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b, #ff930f, #fff95b)"
  },
  {
    id: "gradient12_all-brown",
    gradient: "radial-gradient(circle at 25% 70%, #613400, #351701, #743800, #613400, #351701, #743800, #613400, #351701, #743800)"
  },
  {
    id: "gradient13_slate_and_rose",
    gradient: "radial-gradient(circle at 85% 90%, #177E89, #084C61, #DB3A34, #FFC857, #323031)"
  },
  {
    id: "gradient14_terracotta-chlorophyll",
    gradient: "radial-gradient(circle at 85% 90%, #436436, #D6F599, #D2FF28, #C84C09, #420217)"
  },
  {
    id: "gradient15_platinum-blush",
    gradient: "radial-gradient(circle at 15% 60%, #D8E2DC, #FFE5D9, #D8E2DC, #FFE5D9, #D8E2DC, #FFE5D9, #D8E2DC, #FFE5D9)"
  },
  {
    id: "gradient16_lava-float",
    gradient: "linear-gradient(180deg, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02, #E89005, #EC7505, #D84A05, #F42B03, #E70E02)"
  },
  {
    id: "gradient17_coral-emerald",
    gradient: "linear-gradient(180deg, #EE6055, #FFD97D, #60D394, #AAF683, #FFD97D, #FF9B85, #EE6055, #FFD97D, #60D394, #AAF683, #FFD97D)"
  },
  {
    id: "gradient18_warmer-indigo",
    gradient: "linear-gradient(60deg, #1023FF, #8A4FFF, #4BB3FD, #0496FF, #8A4FDF, #027BCE)"
  },
  {
    id: "gradient19_sunset-with-green",
    gradient: "linear-gradient(60deg, #5CF64A, #87E752, #43B929, #0496FF, #FFCAE9, #FF37A6, #FFCAE9)"
  },
  {
    id: "gradient20_pinksphere",
    gradient: "radial-gradient(circle at 100%, #EF27A6, #F57AC8, #FF299C, #F57AC8, #EF27A6, #F57AC8, #FF299C, #F57AC8, #EF27A6, #F57AC8, #FF299C, #F57AC8, #EF27A6, #F57AC8, #FF299C, #F57AC8, #EF27A6, #F57AC8, #FF299C, #F57AC8, #EF27A6, #F57AC8, #FF299C, #F57AC8)"
  },
  {
    id: "gradient21_sky-without-dust",
    gradient: "radial-gradient(circle at 30% 79%, #7D83FF, #007FFF, #1AFFD5, #7D83FF, #007FFF, #1AFFD5, #7D83FF, #007FFF, #1AFFD5, #7D83FF, #007FFF, #1AFFD5, #7D83FF, #007FFF, #1AFFD5, #7D83FF, #007FFF, #1AFFD5)"
  },
];

class App extends Component {
  constructor(props) {
    super(props);

    this.pngExport = this.pngExport.bind(this);
    this.pngDownloader = this.pngDownloader.bind(this);
    this.gifDownloader = this.gifDownloader.bind(this);
    this.gifExport = this.gifExport.bind(this);

    const selectedGradient =
      gradientSets[this.getRandomInt(0, gradientSets.length)];
    const numberOfDivs = this.getRandomInt(5, 21);
    console.log(
      "World is Turning",
      numberOfDivs,
      "images on",
      selectedGradient.id
    );
    console.log("www.rodellwarner.com/world-is-turning");
    const numberOfImages = numberOfDivs * 1;
    const selectedImages = this.getUniqueRandomImages(numberOfImages, 106);

    this.state = {
      divs: this.initializeDivs(numberOfDivs, selectedImages),
      selectedGradient,
      selectedImages,
    };

    this.updateIntervals = {};
    this.scaleIntervals = {}; // New intervals for scale updates
  }

  componentDidMount() {
    // Register exporters as soon as possible.
    this.registerExporter();

    // Start the update timers:
    // – The image (and position) update is scheduled randomly.
    this.startUpdates();
    // – The scale update is now independent and runs every 300ms.
    this.startScaleUpdates();

    // Adding a 3000ms timeout before calling capture.
    setTimeout(() => {
      void $o.capture();
    }, 3000);
  }

  componentWillUnmount() {
    Object.values(this.updateIntervals).forEach(clearTimeout);
    Object.values(this.scaleIntervals).forEach(clearTimeout);
  }

  getRandomInt(min, max) {
    if (typeof $o !== "undefined" && typeof $o.rnd === "function") {
      return Math.floor($o.rnd() * (max - min) + min);
    } else {
      console.error("$o.rnd() is not available. Falling back to Math.random()");
      return Math.floor(Math.random() * (max - min) + min);
    }
  }

  getRandomScale() {
    if (typeof $o !== "undefined" && typeof $o.rnd === "function") {
      return $o.rnd() * (1.5 - 0.2) + 0.2;
    } else {
      console.error("$o.rnd() is not available. Falling back to Math.random()");
      return Math.random() * (1.5 - 0.2) + 0.2;
    }
  }

  getUniqueRandomImages(count, maxImages) {
    const numbers = new Set();
    while (numbers.size < count) {
      numbers.add(this.getRandomInt(1, maxImages));
    }
    return Array.from(numbers);
  }

  initializeDivs(count, images) {
    return Array.from({ length: count }, () => ({
      currentImage: images[this.getRandomInt(0, images.length)],
      scale: this.getRandomScale(),
      position: this.getRandomPosition(),
    }));
  }

  getRandomPosition() {
    return {
      top: `${this.getRandomInt(-20, 120)}%`,
      left: `${this.getRandomInt(-20, 120)}%`,
    };
  }

  startUpdates() {
    // Update the image and position at random intervals.
    // The scale property is no longer updated here.
    this.state.divs.forEach((_, index) => {
      const updateDiv = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index], // Preserve the current scale.
            currentImage:
              prevState.selectedImages[
                this.getRandomInt(0, prevState.selectedImages.length)
              ],
            position: this.getRandomPosition(),
          };
          return { divs: newDivs };
        });
        this.updateIntervals[index] = setTimeout(
          updateDiv,
          this.getRandomInt(200, 5000)
        );
      };
      this.updateIntervals[index] = setTimeout(
        updateDiv,
        this.getRandomInt(200, 5000)
      );
    });
  }

  startScaleUpdates() {
    // Independently update the scale at random intervals between 500ms and 2000ms.
    this.state.divs.forEach((_, index) => {
      const updateScale = () => {
        this.setState((prevState) => {
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            ...newDivs[index],
            scale: this.getRandomScale(),
          };
          return { divs: newDivs };
        });
        this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
      };
      this.scaleIntervals[index] = setTimeout(updateScale, this.getRandomInt(500, 2000));
    });
  }
  

  async gifDownloader(args) {
    const url = await this.gifExport(args);
    const link = document.createElement("a");
    link.download = "export.gif";
    link.href = url;
    link.click();
  }

  gifExport({ resolution: { x = 400, y = 400 } }) {
    return new Promise((resolve, _) => {
      const appElement = document.querySelector(".App");
      const canvasElement = document.getElementById("captureCanvas");

      if (!appElement || !canvasElement) {
        console.error("App element or canvas element is missing!");
        return;
      }

      // Set up the canvas resolution
      canvasElement.width = x;
      canvasElement.height = y;
      const ctx = canvasElement.getContext("2d");

      const gif = new GIF({
        workers: 2, // Number of workers for parallel processing
        quality: 1, // Higher number means lower quality
        width: x,
        height: y,
      });

      const frameCount = 1; // Number of frames for the animation
      const frameDelay = 12; // Delay per frame in milliseconds
      let currentFrame = 0;

      const drawFrame = () => {
        // Clear the canvas
        ctx.clearRect(0, 0, x, y);

        // Draw the gradient background
        const gradient = appElement.style.background; // Get the gradient from the .App style
        if (gradient) {
          const gradientWidth = x * 7; // Mimicking 700% scale
          const gradientHeight = y * 7;
          const backgroundGradient = ctx.createLinearGradient(0, 0, gradientWidth, gradientHeight);

          const gradientColors = gradient.match(/#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/g);

          if (gradientColors && gradientColors.length > 1) {
            gradientColors.forEach((color, index) => {
              backgroundGradient.addColorStop(index / (gradientColors.length - 1), color);
            });
          }

          ctx.fillStyle = backgroundGradient;
          ctx.fillRect(0, 0, x, y);
        } else {
          ctx.fillStyle = "#ffffff"; // Default to white
          ctx.fillRect(0, 0, x, y);
        }

        // Draw animated images
        this.state.divs.forEach((div) => {
          const img = new Image();
          img.src = require(`./images/${div.currentImage}.gif`);

          // Scale and position the image
          const imgWidth = img.width * div.scale;
          const imgHeight = img.height * div.scale;
          const xPos = (x / 2) + (parseFloat(div.position.left) / 100) * x;
          const yPos = (y / 2) + (parseFloat(div.position.top) / 100) * y;

          ctx.drawImage(img, xPos - imgWidth / 2, yPos - imgHeight / 2, imgWidth, imgHeight);
        });

        // Add the current canvas frame to the GIF
        gif.addFrame(canvasElement, { copy: true, delay: frameDelay });
      };

      const renderFrames = () => {
        if (currentFrame < frameCount) {
          drawFrame(); // Draw the current frame
          currentFrame++;
          setTimeout(renderFrames, frameDelay); // Schedule the next frame
        } else {
          // Finish rendering the GIF
          gif.on("finished", (blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              resolve(reader.result); // Base64 Data URI
            };
          });

          gif.render(); // Start the rendering process
        }
      };

      // Start rendering frames
      renderFrames();
    });
  }

  async pngDownloader(args) {
    const url = await this.pngExport(args);
    const link = document.createElement("a");
    link.download = "export.png";
    link.href = url;
    link.click();
  }

  pngExport({ resolution: { x, y } }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const appElement = document.querySelector(".App");
        const canvasElement = document.getElementById("captureCanvas");

        if (!appElement || !canvasElement) {
          console.error('App element or canvas element is missing!');
          return;
        }

        // Ensure the canvas is cleared and set up with the correct resolution
        canvasElement.width = x;
        canvasElement.height = y;
        const ctx = canvasElement.getContext("2d");

        // Clear the canvas
        ctx.clearRect(0, 0, x, y);

        // Draw the stretched gradient background
        const gradient = appElement.style.background; // Get the gradient from the .App style
        if (gradient) {
          // Create a large gradient to mimic the stretching effect
          const gradientWidth = x * 7;  // Scale it up by 7 times (mimicking 700%)
          const gradientHeight = y * 7; // Scale it up by 7 times (mimicking 700%)
          const backgroundGradient = ctx.createLinearGradient(0, 0, gradientWidth, gradientHeight);

          // Extract colors from the gradient string
          const gradientColors = gradient.match(/#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/g);

          if (gradientColors && gradientColors.length > 1) {
            // Apply gradient colors based on the extracted colors
            gradientColors.forEach((color, index) => {
              backgroundGradient.addColorStop(index / (gradientColors.length - 1), color);
            });
          } else {
            // Fallback to just using a solid color if no valid gradient is found
            ctx.fillStyle = gradient || '#fff'; // Default to white if no gradient is found
            ctx.fillRect(0, 0, x, y); // Fill the entire canvas with the gradient
          }

          // Apply the large stretched gradient to the canvas
          ctx.fillStyle = backgroundGradient;
          ctx.fillRect(0, 0, x, y);
        } else {
          // If no gradient is set, fall back to a solid background color
          ctx.fillStyle = "#ffffff"; // You can adjust the fallback color here
          ctx.fillRect(0, 0, x, y);
        }

        let loadedImages = 0;
        const totalImages = this.state.divs.length;

        // Function to handle drawing images once they are loaded
        const drawImages = () => {
          this.state.divs.forEach(div => {
            const img = new Image();
            img.src = require(`./images/${div.currentImage}.gif`);

            // Wait until image is fully loaded before drawing
            img.onload = () => {
              loadedImages++;

              // Ensure correct scaling and positioning
              const imgWidth = img.width * div.scale;
              const imgHeight = img.height * div.scale;

              // Calculating position based on resolution and percentage
              const xPos = (x / 2) + (parseFloat(div.position.left) / 100) * x;
              const yPos = (y / 2) + (parseFloat(div.position.top) / 100) * y;

              // Log the image position for debugging
              console.log(`Image: ${div.currentImage} - Position: (${xPos}, ${yPos}) - Scale: ${div.scale}`);

              // Draw the image on the canvas
              ctx.drawImage(img, xPos - imgWidth / 2, yPos - imgHeight / 2, imgWidth, imgHeight);

              // Trigger the download once all images are loaded
              if (loadedImages === totalImages) {
                resolve(canvasElement.toDataURL("image/png"));
              }
            };

            // Handle error if image fails to load
            img.onerror = (error) => {
              console.error(`Failed to load image: ${div.currentImage}`, error);
              reject(error);
            };
          });
        };

        // Start drawing images once assets are ready
        drawImages();
      }, 1000);  // Introduce a 1-second delay before starting
    });
  }

  goFullScreen = () => {
    const element = document.querySelector(".App");
    if (screenfull.isEnabled && element) {
      screenfull.request(element);
    }
  };

  registerExporter() {
    if (window.$o) {
      window.$o.registerExport(
        { mime: "image/png", resolution: { x: 1024, y: 1024 }, default: true },
        this.pngExport
      );

      window.$o.registerExport(
        { mime: "image/gif", resolution: { x: 400, y: 400 }, thumb: true },
        this.gifExport
      );
    }
  }

  render() {
    const { selectedGradient } = this.state;

    return (
      <div
        className="App"
        style={{
          background: selectedGradient.gradient,
          backgroundSize: "700% 700%",
          animation: "AnimationName 60s ease infinite",
        }}
      >
        {this.state.divs.map((div, index) => (
          <div
            className="theArt"
            key={index}
            onClick={() => this.goFullScreen()}
            style={{
              position: "absolute",
              top: div.position.top,
              left: div.position.left,
              transform: `translate(-50%, -50%) scale(${div.scale})`,
            }}
          >
            <img src={require(`./images/${div.currentImage}.gif`)} alt={`art${index + 1}`} />
          </div>
        ))}
        <canvas id="captureCanvas" style={{ display: "none" }}></canvas>

        {/* Add buttons for exporting */}
        {/* <div
          style={{
          position: "fixed",
          top: "50%", // Center vertically
          left: "50%", // Center horizontally
          transform: "translate(-50%, -40%)", // Adjust slightly above the exact center
          zIndex: 1000, // Ensure they appear on top
          display: "flex",
          flexDirection: "column", // Stack buttons vertically
          gap: "10px", // Space between buttons
          }}
          >
          <button
          onClick={() => this.pngDownloader({ resolution: { x: 1024, y: 1024 } })}
          style={{
            padding: "10px 15px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          >
          Export PNG
          </button>
          <button onClick={() => this.gifDownloader({ resolution: { x: 400, y: 400 } })}
          style={{
            padding: "10px 15px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            }}>
                Export GIF
              </button>
      
      </div> */}

      
      </div>
    );
  }
}

export default App;